import { InjectionToken, Provider } from '@angular/core';
import { environment } from '../environments/environment';

export const IFRAME_PATH = new InjectionToken<string>('IFRAME_PATH');

export const IFRAME_TARGET_ORIGIN = new InjectionToken<string>('IFRAME_TARGET_ORIGIN');

export const WINDOW = new InjectionToken<string>('WINDOW');

export const TOKENS: Provider[] = [
  { provide: IFRAME_PATH, useValue: environment.iframePath },
  { provide: IFRAME_TARGET_ORIGIN, useValue: environment.iframeTargetOrigin },
  { provide: WINDOW, useValue: window }
];
